// @flow
import React, { Component } from 'react'
import { Card, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import ApiService from '../../actions/apiService';
import ReactMarkdown from 'react-markdown'

class Disclaimer extends Component {
  
  state = {
    content: 'Disclaimer',
    isLoading: true,
  }
  
  async componentWillMount() {
    const response = await ApiService.getMethod('/pages/disclaimer');
    if (response) {
      this.setState({
        content: response,
      })
    }
    this.setState({
      isLoading: false,
    });
  }
  
  render() {
    
    return (
      <StyledContent>
        <StyledMember>
          <Card title="Disclaimer" bordered={false}>
            {
              this.state.isLoading ? <Spin/> : <ReactMarkdown escapeHtml={false} source={this.state.content} />
            }
          </Card>
        </StyledMember>
      </StyledContent>
    )
  }
}

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/static/Disclaimer.js